<div class="main">
    <img [src]="args.imageDownloadUrl" alt="">
</div>